(function(){
    angular.module('tmx-app').directive("breadcrumbs", breadcrumbsDirective);

    function breadcrumbsDirective() {
	    return {
	        restrict: 'E',
	        priority: 100,
	        templateUrl: 'common/directives/breadcrumbs/breadcrumbs.html',
		    controller: ['Breadcrumbs','menu','$state','tmxUtility',breadcrumbsCtrl],
		    controllerAs:'breadcrumbsCtrl'
	    };
    }
    var exists;
    function breadcrumbsCtrl(Breadcrumbs,menu,$state,tmxUtility){
        var vm=this;
        vm.Name="Ahsan";
        vm.Breadcrumbs=Breadcrumbs;
        vm.menu=menu;
        vm.Breadcrumbs.generate();
        vm.changeState=ChangeState;
        vm.setIcon = setIcon;
        exists=tmxUtility.exists;

        vm.setIcon(menu.pages.sections);

        function setIcon(json) {
            var stateName = $state.current.name.replace(/\.add\s*$/, "").replace(/\.edit\s*$/, "").replace(/\.info\s*$/, "").replace(/\.summary\s*$/, "");														
            var array = [];
            angular.forEach(json, function (sections) {
                if (angular.isDefined(sections.pages)) {
                    angular.forEach(sections.pages, function (pages) {
                        if (!angular.isDefined(pages.pages)) {
						
                            if ('private.' + pages.route.toLowerCase() == stateName + '.view')
                                vm.icon = pages.icon;
                        }
                        else {
                            array = [];
                            array.push(pages);
                            setIcon(array);
                        }

                    })
                }
                else {
                    if ('private.' +sections.route.toLowerCase() == stateName + '.view')
                        vm.icon = sections.icon;
                }

            });
        }


        vm.formatTitle=function(title){
            if(title.toLowerCase()=='edit'){
                if(exists($state,"data.info") && $state.data.info){
                    return "View";
                }
            }
			// if(title.toLowerCase()=='dashboard')
			// {
			//     return 'Inbox';
			// }

            return title;
        }

        function ChangeState(state){
            vm.menu.changeState(state);
        }

    }
})();